import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const SplideServices = () => {
  // 🔹 Dummy images – replace with your own local image paths
  const images = [
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM (1).jpeg",
    // "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM (2).jpeg",
    // "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM (3).jpeg",
    // "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM (4).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM (5).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.51 PM.jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (2).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (3).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (4).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (5).jpeg",
    // "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (5).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM (6).jpeg",
    "/imgsec/WhatsApp Image 2025-09-07 at 9.41.52 PM.jpeg",
  ];

  return (
    <div className="pb-5">
       <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="mb-5">Our Prestigious Clients</h1>
        </div>
    <Splide
      options={{
        type: "loop",
        perPage: 5,
        perMove: 1,
        gap: "1rem",
        autoplay: true,
        interval: 2000,
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        resetProgress: false,
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
          640: { perPage: 1 },
        },
      }}
      aria-label="Service Images"
    >
      {images.map((src, idx) => (
        <SplideSlide key={idx}>
          <img
            src={src}
            alt={`Slide ${idx + 1}`}
            className="w-auto object-contain rounded-lg mx-auto"
            style={{ height: "150px" }}
          />
        </SplideSlide>
      ))}
    </Splide>
    </div>
  );
};

export default SplideServices;
